.optionLabel {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.newSourceTag {
  margin-left: 8px;
  flex-shrink: 0;
  font-size: 0.75rem;
  font-style: italic;
  color: var(--color-text-secondary);
}
